<div class="mobile-container">
  <!-- Loading 狀態 -->
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
    </div>
    <p class="mt-3">{{ 'chemical.mobile.loading' | translate }}</p>
  </div>

  <!-- 錯誤訊息 -->
  <div *ngIf="error && !loading" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
    <button type="button" class="btn-close" (click)="error = ''" aria-label="Close"></button>
  </div>

  <!-- 成功訊息 -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="fas fa-check-circle me-2"></i>
    {{ successMessage }}
    <button type="button" class="btn-close" (click)="successMessage = ''" aria-label="Close"></button>
  </div>

  <!-- 主要內容 -->
  <div *ngIf="!loading && !error && inventoryData" class="content-wrapper">

    <!-- 化學品資訊卡片 -->
    <div class="info-card">
      <div class="card-header">
        <h1 class="chemical-name">{{ inventoryData.chemicalName }}</h1>
        <span *ngIf="sdsData" class="danger-badge" [ngClass]="getDangerLevelClass()">
          <i class="fas fa-exclamation-triangle"></i>
          {{ getDangerLevelText() }}
        </span>
      </div>

      <div class="card-body">
        <!-- 部門資訊 -->
        <div class="info-row">
          <i class="fas fa-building"></i>
          <div class="info-content">
            <span class="label">{{ 'chemical.mobile.department' | translate }}</span>
            <span class="value">{{ inventoryData.departmentName }}</span>
          </div>
        </div>

        <!-- 當前庫存 -->
        <div class="info-row">
          <i class="fas fa-boxes"></i>
          <div class="info-content">
            <span class="label">{{ 'chemical.mobile.current_stock' | translate }}</span>
            <span class="value stock-value" [ngClass]="getStockStatusClass()">
              {{ inventoryData.currentStock }} {{ inventoryData.unit }}
            </span>
          </div>
        </div>

        <!-- 警戒值 (如果有啟用) -->
        <div *ngIf="inventoryData.enableAlerts" class="info-row">
          <i class="fas fa-bell"></i>
          <div class="info-content">
            <span class="label">{{ 'chemical.mobile.thresholds' | translate }}</span>
            <span class="value">
              {{ 'chemical.mobile.min' | translate }}: {{ inventoryData.minThreshold || '-' }} {{ inventoryData.unit }}
              / {{ 'chemical.mobile.max' | translate }}: {{ inventoryData.maxThreshold || '-' }} {{ inventoryData.unit }}
            </span>
          </div>
        </div>

        <!-- 最後更新時間 -->
        <div class="info-row">
          <i class="fas fa-clock"></i>
          <div class="info-content">
            <span class="label">{{ 'chemical.mobile.last_updated' | translate }}</span>
            <span class="value">{{ inventoryData.lastUpdated | date:'yyyy-MM-dd HH:mm' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- SDS 查看區塊 -->
    <div *ngIf="sdsData" class="sds-section">
      <h2 class="section-title">
        <i class="fas fa-file-pdf"></i>
        {{ 'chemical.mobile.sds_info' | translate }}
      </h2>

      <div class="sds-card">
        <div class="sds-header">
          <div class="chemical-names">
            <div class="name-item">
              <span class="label-sm">{{ 'chemical.mobile.chinese_name' | translate }}</span>
              <span class="value-sm">{{ sdsData.chineseName }}</span>
            </div>
            <div class="name-item">
              <span class="label-sm">{{ 'chemical.mobile.english_name' | translate }}</span>
              <span class="value-sm">{{ sdsData.englishName }}</span>
            </div>
          </div>
        </div>

        <div class="sds-actions">
          <button class="btn btn-primary btn-block" (click)="viewPdf()">
            <i class="fas fa-eye"></i>
            {{ 'chemical.mobile.view_sds' | translate }}
          </button>
          <button class="btn btn-outline-secondary btn-block" (click)="downloadPdf()">
            <i class="fas fa-download"></i>
            {{ 'chemical.mobile.download_sds' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- 庫存操作區塊 -->
    <div class="operations-section">
      <h2 class="section-title">
        <i class="fas fa-edit"></i>
        {{ 'chemical.mobile.stock_operations' | translate }}
      </h2>

      <div class="operation-buttons">
        <button class="btn btn-success btn-lg btn-block" (click)="openOperationForm('in')">
          <i class="fas fa-plus-circle"></i>
          {{ 'chemical.mobile.operation.in' | translate }}
        </button>
        <button class="btn btn-danger btn-lg btn-block" (click)="openOperationForm('out')">
          <i class="fas fa-minus-circle"></i>
          {{ 'chemical.mobile.operation.out' | translate }}
        </button>
        <button class="btn btn-warning btn-lg btn-block" (click)="openOperationForm('update')">
          <i class="fas fa-sync-alt"></i>
          {{ 'chemical.mobile.operation.update' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- 操作表單 Modal -->
  <div *ngIf="showOperationForm" class="modal-overlay" (click)="closeOperationForm()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">{{ getOperationTitle() }}</h3>
        <button type="button" class="btn-close" (click)="closeOperationForm()"></button>
      </div>

      <div class="modal-body">
        <!-- 當前庫存提示 -->
        <div class="current-stock-display">
          <span class="label">{{ 'chemical.mobile.current_stock' | translate }}</span>
          <span class="value">{{ inventoryData.currentStock }} {{ inventoryData.unit }}</span>
        </div>

        <!-- 數量輸入 -->
        <div class="form-group">
          <label for="quantity">
            <span *ngIf="operationType === 'in'">{{ 'chemical.mobile.quantity_to_add' | translate }}</span>
            <span *ngIf="operationType === 'out'">{{ 'chemical.mobile.quantity_to_remove' | translate }}</span>
            <span *ngIf="operationType === 'update'">{{ 'chemical.mobile.new_total' | translate }}</span>
          </label>
          <input
            type="number"
            id="quantity"
            class="form-control form-control-lg"
            [(ngModel)]="quantity"
            [placeholder]="'chemical.mobile.enter_quantity' | translate"
            min="0"
            step="0.01">
          <small class="form-text text-muted">{{ 'chemical.mobile.unit' | translate }}: {{ inventoryData.unit }}</small>
        </div>

        <!-- 備註輸入 -->
        <div class="form-group">
          <label for="note">{{ 'chemical.mobile.note' | translate }} ({{ 'common.optional' | translate }})</label>
          <textarea
            id="note"
            class="form-control"
            [(ngModel)]="note"
            [placeholder]="'chemical.mobile.enter_note' | translate"
            rows="3"></textarea>
        </div>

        <!-- 錯誤訊息 (在 modal 內) -->
        <div *ngIf="error" class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeOperationForm()">
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="performStockOperation()"
          [disabled]="loadingOperation">
          <span *ngIf="loadingOperation" class="spinner-border spinner-border-sm me-2"></span>
          {{ 'common.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- PDF Viewer Modal (簡化版，Phase 1 使用 iframe) -->
  <div *ngIf="showPdfViewer" class="modal-overlay" (click)="closePdfViewer()">
    <div class="modal-content modal-pdf" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">{{ 'chemical.mobile.sds_pdf' | translate }}</h3>
        <button type="button" class="btn-close" (click)="closePdfViewer()"></button>
      </div>
      <div class="modal-body pdf-body">
        <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" class="pdf-iframe" frameborder="0"></iframe>
        <div *ngIf="!safePdfUrl" class="text-center p-4">
          <p>{{ 'chemical.mobile.loading_pdf' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
